import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e172064"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-card-item-wrap" }
const _hoisted_2 = { class: "block-card-item" }
const _hoisted_3 = { class: "block-card-item-image" }
const _hoisted_4 = { class: "block-card-item-text-wrap" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  __name: 'block-card-item',
  props: {
  /** Заголовок  */
  title: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    default: "",
  },
  image: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          style: _normalizeStyle({backgroundImage:'url('+__props.image+')'}),
          class: "card-item-image"
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "block-card-item-title",
          innerHTML: __props.title
        }, null, 8, _hoisted_5),
        _createElementVNode("div", {
          class: "block-card-item-text",
          innerHTML: __props.text
        }, null, 8, _hoisted_6)
      ])
    ])
  ]))
}
}

})